import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function Forecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  function handleResponse(response) {
    console.log(response);
    setForecast(response.data.daily);
    setLoaded(true);
  }

  if (loaded) {
    return (
      <div className="row">
        <div className="col-sm-2">
          <WeatherForecastDay data={forecast[0]} />
        </div>
        <div className="col-sm-2">
          <WeatherForecastDay data={forecast[1]} />
        </div>
        <div className="col-sm-2">
          <WeatherForecastDay data={forecast[2]} />
        </div>
        <div className="col-sm-2">
          <WeatherForecastDay data={forecast[3]} />
        </div>
        <div className="col-sm-2">
          <WeatherForecastDay data={forecast[5]} />
        </div>
      </div>
    );
  } else {
    let apiKey = "bb0d4750adbaf8dd371419162d9174d1";
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${props.coordinates.lat}&lon=${props.coordinates.lon}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);

    return null;
  }
}
